import { appConfigService } from '@/providers/services/app/app-config';
import { PERMISSION_LIST, ROLE_MENUS } from '@/utils/constants';
import { authAPI } from '@/providers/apis/auth/auth';
import { sessionService } from '@/providers/services/auth/session';
import { appConfigAPI } from '@/providers/apis/app/app-config';
import router from '@/routers/router';
import { TenantAccountListModel } from '@/models/auth/session';
import StaticAssetsMixin from '@/helpers/mixins/static-assets-mixin';

/**
 * Permission class help to show UI based on users permissions
 */
export class Permission {

    private static INSTANCE = new Permission();

    static get instance() {
        return this.INSTANCE;
    }

    public get userRole() {
        return appConfigService.getAppUserRole();
    }

    /**
     * Help to identify roles by pages
     */
    public ACL = PERMISSION_LIST;

    /**
     * Help to defined the menu list
     */
    public menus = ROLE_MENUS;

    /**
     * Show the menus based on permission
     * @param value
     */
    public hasMenuAccess(value: any) {
        return this.userRole.menus.indexOf(value) !== -1;
    }

    public isGuestUser(menu: any, value: any) {
        const userRole = this.userRole;
        return false;
    }

    /**
     * Show the pages based on permissions
     * @param component
     * @param value
     */
    public hasPermission(menu: any, value: any) {
        const userRole = this.userRole;
        return userRole.pages[menu]
            ? (userRole.pages[menu].indexOf(value) !== -1 || userRole.pages.all.indexOf('all') !== -1)
            : false;
    }

    /**
     * It hold the landing page for the tenant user
     */
    public landingPage() {
        return this.userRole.landingPage;
    }

    /**
     * help to login as a demo user
     * @param userDetails holding user login credentials
     */
    public async doLoginInWithCredential(userDetails: any) {
        const username = userDetails.username;
        const password = userDetails.password;
        const accessToken =  userDetails.accesToken;
        await authAPI
            .logInWithCredential(username, password, accessToken)
            .then(
                (session) => {
                    this.updateRole(session);
                },
            );
    }

    public async fetchTenantList(email: string, token: string) {
        return await authAPI.getAccountsLogin(email, token);
    }

    public async doLoginInTenantId(tenant: TenantAccountListModel) {
        return await authAPI.getTenantLoginType(tenant);
    }

    public async getLoginType(nonce: string) {
        return authAPI.tenantLoginType(nonce);
    }

    public getLoginPageInfo() {
        return appConfigService.getLoginPageInfo();
    }

    public getIsMygooruHost() {
        return new StaticAssetsMixin().isMygooruHost();
    }

    public setFavIcon(favIconUrl: string) {
        (() => {
            const link: any = document.querySelector('link[rel*=\'icon\']') || document.createElement('link');
            link.type = 'image/x-icon';
            link.rel = 'shortcut icon';
            link.href = favIconUrl;
            document.getElementsByTagName('head')[0].appendChild(link);
        })();
    }

    public getAssets(cdnUrls: any, fileName= 'logo') {
        return new StaticAssetsMixin().getAssets(cdnUrls, fileName);
    }

    public loginBasedOnToken(token: string, queryParam: any = {}) {
        return authAPI
            .signInWithToken(token)
            .then(
                (session) => {
                    return appConfigAPI.getAppPermissions(session.permissions).then((userRole: any) => {
                        if (userRole) {
                            if (queryParam && queryParam.isHideRoleMenu) {
                                session.isHideRoleMenu = JSON.parse(queryParam.isHideRoleMenu);
                            }
                            appConfigService.setAppUserRole(userRole);
                            sessionService.setSession(session);
                            if (queryParam && queryParam.redirectUrl) {
                                document.location.href = document.location.origin + queryParam.redirectUrl;
                            } else {
                                document.location.href = document.location.origin + userRole.landingPage;
                            }
                        }
                    });
                });
    }


    public updateRole(session: any, isReload: boolean = true) {
        if (!sessionService.getDemoSessionCopy()) {
            sessionService.setDemoSessionCopy();
        }
        appConfigAPI.getAppPermissions(session.permissions).then((userRole: any) => {
            if (userRole) {
                appConfigService.setAppUserRole(userRole);
                sessionService.setSession(session);
                router.push(userRole.landingPage);
                if (isReload) {
                    window.location.href = window.location.origin + userRole.landingPage;
                }
                // Remove once the ember js not used on mission control
                if (sessionService.getMcUpdate()) {
                    sessionService.deleteMcUpdate();
                }
                return userRole.landingPage;
            }
        });
    }
}

export default Permission.instance;
